document.addEventListener('DOMContentLoaded', function() {
    AOS.init({
        duration: 1000, // Duración de la animación
        once: true // Si debe animarse solo una vez
    });
});

window.addEventListener('scroll', function() {
    AOS.refresh(); // Forzar la actualización de AOS en el evento de scroll
}); 